<template>
  <b-list-group>
    <b-list-group-item variant="info">
      <i class="fa fa-exclamation" />
      {{ getResultaatGemodereerd(onderdeel).length }} uitkomsten
      <b-list-group>
        <b-list-group-item
          v-for="(item,index) in getResultaatGemodereerd(onderdeel)"
          :key="index"
          variant="info"
        >
          {{ index }}:{{ item }}
        </b-list-group-item>
      </b-list-group>
    </b-list-group-item>
    
    <b-list-group-item>
      <i class="fa fa-refresh" />
      {{ onderdeel.acties.length }} {{ onderdeel.acties.length == 1 ? 'herhaling' : 'herhalingen' }}
    </b-list-group-item>

    <b-list-group-item variant="warning">
      <h3>Conditie uitkomsten</h3>
      <i class="fa fa-exclamation" />
    </b-list-group-item>

    <b-list-group-item>
      <i class="fa fa-exclamation-triangle" />
      {{ onderdeel.gebreken.length }} {{ onderdeel.gebreken.length == 1 ? 'gebrek' : 'gebreken' }}
    </b-list-group-item>
    <b-list-group-item variant="warning">
      <i class="fa fa-magnet" />
      {{ mods.length }} moderators
      <b-list-group>
        <b-list-group-item 
          v-for="(item,index) in mods" 
          :key="index"
        >
          <b-checkbox v-model="item.active">
            <i :class="'fa fa-' + item.type" />
            {{ item.type }} {{ item.jaar }}
          </b-checkbox>
        </b-list-group-item>
      </b-list-group>
    </b-list-group-item>
    <b-list-group-item variant="primary">
      <i class="fa fa-exclamation" />
      {{ groepen.length }} groepen
      <b-list-group>
        <b-list-group-item
          v-for="(item,index) in groepen"
          :key="index"
          variant="info"
        >
          {{ getGroepResultaat2(getResultaatGemodereerd(onderdeel), item) }}
        </b-list-group-item>
      </b-list-group>
    </b-list-group-item>
  </b-list-group>
</template>
<script>
import { prognoseMixin } from "@/mixins/prognoseMixin";

export default {
  name: "Uitkomsten",
  mixins: [prognoseMixin],
  props: {
    onderdeel: {
      type: Object,
      required: true
    }
  }
};
</script>